import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CloseDialog, OpenDialog } from './info.actions';
import { patch } from '@ngxs/store/operators';
import { InfoDialogItem } from 'src/app/models/info-dialog';

export type InfoStateModel = {
  title: string;
  description: string;
  content: InfoDialogItem[];
  showActions: boolean;
  open: boolean;
};

export const initialState: InfoStateModel = {
  title: '',
  description: '',
  content: [],
  showActions: false,
  open: false,
};

@State<InfoStateModel>({
  name: 'info',
  defaults: initialState,
})
@Injectable()
export class InfoState {

  @Selector()
  static open(state: InfoStateModel): boolean {
    return state.open;
  }

  @Selector()
  static title(state: InfoStateModel): string {
    return state.title;
  }

  @Selector()
  static description(state: InfoStateModel): string {
    return state.description;
  }

  @Selector()
  static content(state: InfoStateModel): InfoDialogItem[] {
    return state.content;
  }

  @Selector()
  static showActions(state: InfoStateModel): boolean {
    return state.showActions;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<InfoStateModel>, { title, description, content, showActions }: OpenDialog) {
    context.setState(
      patch({
        open: true,
        title,
        description,
        content,
        showActions,
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<InfoStateModel>) {
    context.setState(initialState);
  }
}
